class FreeDeliveryCard extends HTMLElement {
  static CONFIG = {
    RON: { threshold: 9900, locale: 'ro-RO', decimals: 2 },
    HUF: { threshold: 1000000, locale: 'hu-HU', decimals: 0 },
    EUR: { threshold: 4500, locale: 'de-DE', decimals: 2 },
  };

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartTotal = parseInt(this.dataset.cartTotal) || 0;
    this.currency = this.dataset.currency || '';
    this.config = FreeDeliveryCard.CONFIG[this.currency];
    this.bar = this.querySelector('.free-delivery-card__bar');
    this.text = this.querySelector('.free-delivery-card__text');

    if (!this.config) return;

    this.update();

    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      this.onCartUpdate.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onCartUpdate(event) {
    if (typeof event.cartData.total_price !== 'undefined') {
      this.cartTotal = event.cartData.total_price;
      this.update();
    } else {
      fetch(window.Shopify.routes.root + 'cart.js', {
        headers: { 'Content-Type': 'application/json' },
      })
        .then((r) => r.json())
        .then((cart) => {
          this.cartTotal = cart.total_price;
          this.update();
        });
    }
  }

  update() {
    if (!this.config || !this.bar || !this.text) return;

    const threshold = this.config.threshold;
    const remaining = Math.max(0, threshold - this.cartTotal);
    const percentage = Math.min(100, (this.cartTotal / threshold) * 100);
    const reached = this.cartTotal >= threshold;

    this.bar.style.width = percentage + '%';
    this.bar.style.minWidth = percentage + '%';

    if (reached) {
      this.text.textContent = window.FREE_DELIVERY_STRINGS.success;
      this.classList.add('free-delivery-card--reached');
    } else {
      const formatted = this.formatAmount(remaining);
      this.text.textContent = window.FREE_DELIVERY_STRINGS.remaining.replace('{{ amount }}', formatted);
      this.classList.remove('free-delivery-card--reached');
    }
  }

  formatAmount(amountInCents) {
    const amount = amountInCents / 100;
    const formatted = new Intl.NumberFormat(this.config.locale, {
      minimumFractionDigits: this.config.decimals,
      maximumFractionDigits: this.config.decimals,
    }).format(amount);
    return formatted + ' ' + this.currency;
  }
}

customElements.define('free-delivery-card', FreeDeliveryCard);
